import styled from '@emotion/styled'
import { Button, Props as ButtonsProps } from 'app/components/Button'
import { FlexBox } from 'app/components/FlexBox'
import { Quote } from 'app/components/Icons'
import {
  Props as ReviewProps,
  Review as OriginalReview,
} from 'app/containers/CustomerReviews/Review'
import React, { memo } from 'react'

export interface Props {
  button?: ButtonsProps
  icon?: string
  title?: string
  text?: string
  reviews?: ReviewProps[]
}
export const Feature = memo(function Feature({
  button,
  icon,
  title,
  text,
  reviews,
}: Props) {
  return (
    <Container className="feature-list-item">
      {title ? (
        <Title dial={5} row>
          {icon ? <img src={icon} width="30" height="30" alt={title} /> : null}
          <Label>{title}</Label>
        </Title>
      ) : null}
      {text ? <Text dangerouslySetInnerHTML={{ __html: text }} /> : null}
      {reviews
        ? reviews.map((item, index) =>
            item.user && item.user !== 'Empty' ? (
              <React.Fragment key={index}>
                <Quote />
                <Review {...item} />
              </React.Fragment>
            ) : null,
          )
        : null}
      {button ? (
        <ReviewCTA>
          <Button {...button} />
        </ReviewCTA>
      ) : null}
    </Container>
  )
})
const Container = styled(FlexBox)`
  width: 33%;
  margin-bottom: 3rem;
  padding-right: 2rem;

  @media all and (max-width: 767px) {
    width: 100%;
    margin-bottom: 5rem;
  }
`

const Title = styled(FlexBox)`
  img {
    width: auto;
    height: auto;
    max-width: 1.875rem;
    max-height: 1.875rem;
    margin-right: 1.5rem;
  }

  @media all and (max-width: 767px) {
    img {
      margin-right: 1rem;
    }
  }
`

const Label = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 2rem;

  @media all and (max-width: 767px) {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
`

const Text = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  line-height: 1.5rem;
  margin-top: 0.75rem;

  a {
    color: ${({ theme }) => theme.colors.variants.primary};
  }
`

const ReviewCTA = styled.div`
  a {
    width: 100%;
    max-width: 260px;
    background-color: ${({ theme }) => theme.colors.variants.base};
    border: 2px solid ${({ theme }) => theme.colors.variants.primary};
    color: ${({ theme }) => theme.colors.variants.primary};
    margin-top: 2rem;
    text-align: center;
    &:hover {
      background-color: ${({ theme }) => theme.colors.variants.primary};
      color: ${({ theme }) => theme.colors.variants.base};
    }

    @media all and (max-width: 571px) {
      max-width: none;
      display: block;
      width: 100%;
      margin-bottom: 2.5rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media all and (max-width: 571px) {
    max-width: none;
    display: block;
    width: 100%;
  }
`

/* const Svg = styled(Icon)`
  margin: 1.5rem auto 1rem auto;
  path {
    fill: ${({ theme }) => theme.colors.variants.primary};
  }
` */

const Review = styled(OriginalReview)`
  color: #555;
  padding: 0;
  > div {
    font-family: 'Georgia', 'Times New Roman', Times, serif;
    font-size: 0.9rem;
    font-style: italic;
    line-height: 1.625rem;
    &.review-info {
      display: flex;
      align-items: center;
      margin-top: 2rem;
      img {
        width: 50px;
        height: 50px;
        margin: 0 1rem 0 0;
      }
      div {
        flex: 1;
        font-style: normal;
        font-weight: 700;
        line-height: 1.25rem;
      }
    }
  }
`
